import { render } from "./ActivityHeader.vue?vue&type=template&id=fb770ac2&scoped=true"
import script from "./ActivityHeader.vue?vue&type=script&lang=js"
export * from "./ActivityHeader.vue?vue&type=script&lang=js"

import "./ActivityHeader.vue?vue&type=style&index=0&id=fb770ac2&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb770ac2"]])

export default __exports__